module.exports = __webpack_public_path__ + "img/dzsw-02.2b118816.png";